import { Volume2, Square } from "lucide-react";
import { useTTS } from "@/hooks/useVoice";

/**
 * Tap to read the supplied text aloud. Tap again to stop.
 * Renders nothing if the browser doesn't support speech synthesis.
 */
export default function SpeakButton({
  text,
  label = "Read aloud",
  size = "sm",
  className = "",
  testid,
}) {
  const { supported, speaking, speak, stop } = useTTS();
  if (!supported) return null;

  const onClick = () => {
    if (speaking) stop();
    else speak(text);
  };

  const dim = size === "sm" ? 14 : 16;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`weave-voice-btn ${speaking ? "is-active" : ""} ${className}`}
      aria-label={speaking ? "Stop reading" : label}
      title={speaking ? "Stop reading" : label}
      data-testid={testid}
    >
      {speaking ? <Square size={dim} /> : <Volume2 size={dim} />}
      <span className="text-xs font-medium">
        {speaking ? "Stop" : "Listen"}
      </span>
    </button>
  );
}
